// extracted by mini-css-extract-plugin
export default {"container":"styles_container__wwcYj","districtNameText":"styles_districtNameText__xqPM0","icon":"styles_icon__dwUYF"};